<template>
    <div ref="selectDomRef">
        <a-tree-select class="custom-comp"
            style="position: relative"
            v-model:value="currentValue"
            :tree-data="treeOptions"
            :replace-fields="replaceFields"
            tree-checkable
            allow-clear
            :disabled="disabled"
            :labelInValue="true"
            :treeCheckStrictly="false"
            :treeNodeFilterProp="replaceFields.title"
            show-search
            :placeholder="showPlaceHolder ? '请选择' + column.columnComment : ''"
            :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
            @change="changeTreeSelect"
        />
    </div>
</template>

<script lang="ts" name="filterCommonTree" setup>
import { reactive, ref, watch } from 'vue';
import { customQuery } from '../api';
import { getDictItemsByCode } from '/@/utils/dict';
import useExtraPlaceholder from '../hooks/useExtraPlaceholder';
const props = defineProps({
    rule: String,
    column: Object,
    value: [Array, String],
    disabled: Boolean,
});

const currentValue = ref([])
const treeOptions = ref([])
let maxCount = null;
let formerSelected = [];

const selectDomRef = ref(null)
const { showPlaceHolder } = useExtraPlaceholder(selectDomRef, '.ant-select-selection-search-input')

const replaceFields = reactive({
    children: 'children',
    title: 'title',
    key: 'key',
    value: 'value',
})

const emit = defineEmits(['update:value', 'change'])

watch(() => props.value, (value: Array<String>) => {
    currentValue.value = value;
    whetherDisableOptions();
}, {
    immediate: true,
})

watch(() => props.column, () => {
    initOptions()
}, {
    immediate: true,
})

function changeTreeSelect(selected) {
    if (selected.length > maxCount) {
        const thisTimeSelected = selected.filter(item => !isInSelected(item[replaceFields.value], formerSelected));
        const shouldErased = thisTimeSelected.slice(maxCount - selected.length, thisTimeSelected.length);
        currentValue.value = currentValue.value.filter(item => !isInSelected(item[replaceFields.value], shouldErased))
    }
    whetherDisableOptions()
    emit('update:value', currentValue.value);
    emit('change', currentValue.value);
    formerSelected = currentValue.value?.slice() || [];
}

function whetherDisableOptions() {
    if (!maxCount) {
        return;
    }
    if (currentValue.value?.length >= maxCount) {
        recursionOptionDisable(true, treeOptions.value, currentValue.value)
    } else {
        recursionOptionDisable(false, treeOptions.value, currentValue.value)
    }
}

function childrenIsInSelected(item) {
    return item.children?.some(childItem => isInSelected(childItem[replaceFields.value]) || childrenIsInSelected(childItem))
}

function isInSelected(value, source=currentValue.value) {
    return source.some(item => item[replaceFields.value] === value)
}

function recursionOptionDisable(disabled: boolean, treeOptions: Array<any>, selected: Array<string>) {
    if (!treeOptions?.length) {
        return;
    }
    treeOptions.forEach(item => {
        item.disabled = disabled && !isInSelected(item[replaceFields.value]) && !childrenIsInSelected(item);
        recursionOptionDisable(disabled, item.children, selected)
    })
}

function getRecursionDictOptions(dictValue) {
    if (!dictValue) {
        return [];
    }
    const dictIsPublic = props.column.dictTypeFlag !== 'private';
    const dictOptions = getDictItemsByCode(dictValue, dictIsPublic) || []
    const outerOptions = dictOptions.map(item => ({...item}));
    outerOptions.forEach(item => {
      let childrenData = getRecursionDictOptions(item.description)

      item[replaceFields.children] = childrenData;
    })

    return outerOptions;
}

async function initOptions() {
    maxCount = props.column.optionMaxNum;
    treeOptions.value = []
    formerSelected = [];

    if (props.column.dictType) {
        treeOptions.value = getRecursionDictOptions(props.column.dictType)
        return;
    }

    let options = [];
    const { interfaceUrl, interfaceMethod, returnParameterMapping } = props.column
    const { labelKey, valueKey } = (returnParameterMapping || {});
    if (interfaceUrl && interfaceMethod) {
        const result = await customQuery({url: interfaceUrl, method: interfaceMethod}) || [];
        replaceFields.title = labelKey ?? 'title';
        replaceFields.value = valueKey ?? 'value';
        options = result;
    }

    treeOptions.value = options;
}

</script>

<style lang="less" scoped>
:deep(.ant-select) {
    width: 100%;
}
:deep(.ant-select-selector) {
    max-height: 220px;
    overflow: auto;
}

.custom-comp {
    width: 100%;
}
:deep(.ant-select-selection-search) {
    width: 80%!important;
}
</style>
